module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-08-26e0d3bb4c0394f602368ebbfc5cf3fc.jpg";